import styled, { css } from 'styled-components';
import { propStyling } from '../../../shared/propStyling';
import { tombac } from '../../../shared/tombac';
const sizeStyles = tombac.variant('size', {
  s: css(["width:", ";"], tombac.unit(288)),
  m: css(["width:", ";"], tombac.unit(496)),
  l: css(["width:", ";"], tombac.unit(715))
});
export const ModalLayout = styled.div.attrs(_ref => {
  let {
    size
  } = _ref;
  return {
    size: size !== null && size !== void 0 ? size : 'm'
  };
}).withConfig({
  displayName: "ModalLayout"
})(["display:flex;flex-direction:column;max-height:85vh;position:relative;", " ", ";"], sizeStyles, propStyling);
//# sourceMappingURL=ModalLayout.js.map